import { ByteString, FixedLengthByteString } from "./ByteString.js";
export const Ed25519 = {
    async generateKey() {
        const keyPair = await crypto.subtle.generateKey("Ed25519", true, ["sign", "verify"]);
        const privateKeyPkcs8 = await crypto.subtle.exportKey("pkcs8", keyPair.privateKey);
        return {
            publicKey: Ed25519Pk.fromBuffer(await crypto.subtle.exportKey("raw", keyPair.publicKey)),
            secretKey: Ed25519Sk.fromBuffer(privateKeyPkcs8.slice(16)),
        };
    },
    async sign(secretKey, payload) {
        const key = await crypto.subtle.importKey("pkcs8", ByteString.of(...[48, 46, 2, 1, 0, 48, 5, 6, 3, 43, 101, 112, 4, 34, 4, 32], ...secretKey), "Ed25519", false, ["sign"]);
        return Ed25519Signature.fromBuffer(await crypto.subtle.sign("Ed25519", key, payload));
    },
    async verify(publicKey, signature, data) {
        const key = await crypto.subtle.importKey("raw", publicKey, "Ed25519", true, ["verify"]);
        return await crypto.subtle.verify("Ed25519", key, signature, data);
    },
};
export class Ed25519Pk extends FixedLengthByteString(32) {
}
export class Ed25519Sk extends FixedLengthByteString(32) {
}
export class Ed25519Signature extends FixedLengthByteString(64) {
}
//# sourceMappingURL=Ed25519.js.map